import * as firebase from 'firebase/app';
import 'firebase/firestore';
import { functions, dueDateStatsCollection }    from '@/db/firestore.ts';
import { Repository } from '@/db/_repo';
import { DueDateStatsModel } from '@/models/DueDateStats';
import { Mapper } from '@/db/Mapper';

export class DueDateStats {

  public mapper = new Mapper(DueDateStatsModel);

  public add(model: DueDateStatsModel) {
    return dueDateStatsCollection.add(model);
  }

  public async addAsync(model: DueDateStatsModel) {
    const ref = await dueDateStatsCollection.add(model);
    const snapshot = await ref.get();
    const data = this.mapper.AutoMap(snapshot);
    return data;
  }

  public async getByUserAsync(userId: string): Promise<DueDateStatsModel[]> {
    const ref = dueDateStatsCollection.where('userId', '==', userId).orderBy('dueDate', 'desc').limit(15);
    const snapshot = await ref.get();
    const data = this.mapper.AutoMapList(snapshot);
    return data;
  }

  public async getByIdAsync(id: string): Promise<DueDateStatsModel> {
    const ref = await dueDateStatsCollection.doc(id);
    const snapshot = await ref.get();
    const data = this.mapper.AutoMap(snapshot);
    return data;
  }

}
